<script setup>
import { computed } from 'vue';
import Prohibit from '@components/offer-card/icons/Prohibit.vue';
import { trans } from '@elements/translation';

const props = defineProps({
  proposal: {
    type: Object,
    required: true,
  },
});

const show = computed(() => props.proposal.is_removed);
</script>

<template>
  <span v-if="show" class="hit-label hit-label--proposal_removed">
    <Prohibit />
    {{ trans('offer_card.labels.proposal_removed') }}
  </span>
</template>
